// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tour-details {
  max-width: 1280px;
  margin: 0 auto;
  padding: 20px;
}
.tour-details h1{
  font-size: 2rem;
  margin-bottom: 1rem;
  color: white;
  text-shadow: 5px 5px 4px rgba(0, 0, 0, 0.486);
}
.tour-details h2{
  font-size: 1.2rem;
  color: #004D00;  
  text-align: left;
}
.tour-details p{
  padding: 10px 0px;
  font-size: 0.9rem;
  line-height: 2;
  color: #1a1919;
  margin-bottom: 1.5rem;
}
/* Hero Section */
.tour-hero {
  display: flex;
  height: 40rem;
  margin: 20px 0;
}
.main-image-container {
  flex: 1 1;
  position: relative;
}
.main-image-container::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: linear-gradient(to bottom, transparent, rgba(2, 2, 2, 0.7));
  border-radius: 16px;
}
.tour-hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
}

.tour-hero-content {
  position: absolute;
  bottom: 40px;
  left: 40px;
  color: white;
  z-index: 1;
}

.tour-meta {
  display: flex;
  gap: 2rem;
}

.tour-meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.1rem;
}
.thumbnail-gallery-vertical {
  flex: 0.2 1;
  min-width: 250px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background: rgba(255, 255, 255, 0.315);
  border-radius: 16px;
  align-self: center;
  overflow-y: auto;
  scrollbar-width: none; 
}
.thumbnail-gallery-vertical::-webkit-scrollbar {
  display: none; 
}
.thumbnail-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.thumbnail-image:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.thumbnail-image.selected {
  border-color: #e8c140;
}


/* Navigation */
.tour-nav {
  display: flex;
  gap: 1rem;
  border-bottom: 1px solid #ddd;
  padding: 0;
  margin: 0;
}

.tour-nav-item {
  padding: 1rem 2rem;
  font-weight: 600;
  color: #000;
  cursor: pointer;
  border-bottom: 3px solid transparent;
}

.tour-nav-item.active {
  border-bottom: 3px solid #004D00;
  color: #004D00;
}

/* Content Layout */
.tour-details-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  margin-top: 2rem;
}
/* overview */
.tour-overview {
  max-width: 1000px;
  margin: 0 auto;
}

.tour-overview h2 {
  color: #004D00;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 24px;
  position: relative;
}

.tour-overview p {
  color: #555;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  margin-bottom: 20px;
}

/* Activities Section */
.activities {
  margin-top: 20px;
}

.activities-title {
  color: #004d00;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
}

.activities-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.activities-list li {
  color: #555;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.activities-list li::before {
  content: "✓";
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #eefaf0;
  color: #00a650;
  border-radius: 50%;
  font-size: 12px;
}
  /* Itinerary Styling */
.tour-itinerary h2 {
  color: #004D00;
  font-size: 20px;
  margin-bottom: 20px;
}

.itinerary-day {
  background: #fff;
  margin-bottom: 15px;
  border-radius: 4px;
}

.day-header {
  padding: 15px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.day-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1rem;

}

.day-number {
  color: #004D00;
  font-weight: 600;
}

.day-title h3 {
  margin: 0;
  font-size: 16px;
  color: #004D00;
}

.toggle-btn {
  width: 24px;
  height: 24px;
  border: 1px solid #004D00;
  background: transparent;
  color: #004D00;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding: 0;
}

.day-content {
  padding: 1.25rem;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  font-size: 0.9rem;
}
.timeline {
  font-size: 0.9rem;
}
.day-content .timeline ul {
  padding: 0 20px;  
  margin: 0;
  list-style-position: outside;
}

.day-content .timeline p,
.day-content .timeline li {
  margin: 0;
  padding: 0;
  line-height: 1.5;
  font-size: 0.9rem;
  color: #1a1919;
}

.day-image {
  width: 100%;
  height: 280px;
  margin-bottom: 20px;
  border-radius: 5px;
  overflow: hidden;
}

.itinerary-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.itinerary-image:hover {
  transform: scale(1.05);
}



/* Includes/Excludes Section */
.includes-excludes {
  margin-top: 30px;
}

.includes-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.inclusions h2,
.exclusions h2 {
  color: #004D00;
  font-size: 20px;
  margin-bottom: 20px;
}

.inclusion-list,
.exclusion-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.inclusion-list li,
.exclusion-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 14px;
}

.icon-check {
  color: #004D00;
  font-weight: bold;
}

.icon-cross {
  color: #dc3545;
  font-weight: bold;
}

/* Sidebar */

.details-destination{
  font-size: 0.8rem;
  background-color: #fff;
  color: #004d00;
  border: 1px solid #004D00;
  padding: 0.4rem;
  border-radius: 5px;
  font-weight: 500;
}
.details-price{
  font-size: 1.2rem;
  font-weight: 700;
  color: #004d00;
}
.image-and-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  width: 100%;
  padding: 10px 10px;
}

.main-image-container {
  position: relative;
  margin-right: 20px;
}

.main-image {
  width: 100%;
  height: 470px;
  object-fit: cover;
  border-radius: 10px;
}

.info-section h3 {
  margin: 10px 0;
  font-size: 1rem;
  font-weight: 700;
}
.info-section p{
  font-size: 0.8rem;
  color: #4e4d4d;
  padding: 0;
}
.info-section button{
  color: white !important;
  width: 100px;
  font-size: 0.9rem !important;
  align-self: flex-end;
}

.styled-datepicker-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  color: #004D00;
  margin-top: 5px;
}

.styled-datepicker-calendar {
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.styled-input{
  width: 100%;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
}


.main-content {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  max-width: 1280px;
  margin: 0 auto;
}
/* itinerary */

.itinerary-list {
  margin-top: 1.5rem;
}

.itinerary-day {
  margin-bottom: 1rem;
}

.day-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
}

.day-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2a2a2a;
  font-size: 1rem;
  font-weight: 500;
}

.location-icon {
  color: #e8c140;
  font-size: 1.2rem;
}
.icon-text {
  color: #e8c140;
  margin-top: 1rem;
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;
}
.icon-text span {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
}

.itinerary-icon {
  font-size: 1rem;
}
.includes-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-top: 1rem;
}

.inclusions, .exclusions {
  padding: 2rem;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #eee;
}

.inclusions h2, .exclusions h2 {
  color: #004D00;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.inclusion-list, .exclusion-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.inclusion-list li, .exclusion-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0;
  color: #4a4a4a;
  font-size: 0.95rem;
}
.icon-check{
  content: "✓";
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #eefaf0;
  color: #00a650;
  border-radius: 50%;
  font-size: 12px;
}

.icon-cross{
  content: "×";
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #fff1f0;
  color: #ff4d4f;
  border-radius: 50%;
  font-size: 14px;
}



.you-might-like{
  color: #004d00;
  font-size: 20px;
  font-weight: 600;
  margin: 0.5rem 1rem;

}
/* rates */
.tour-rates{
  background: #fff;
}
.rate-table{
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
}
.rate-table th,
.rate-table td {
  padding: 15px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.rate-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 0.7rem;
  white-space: pre-line;
}

.rate-table tr:hover {
  background-color: #f5f5f5;
}

.rate-table td:first-child {
  text-align: left;
  font-weight: 500;
  color: #444;
}

.rate-table td {
  font-size: 0.8rem;
  color: #666;
}

/* Price cells */
.rate-table td:not(:first-child):not(:last-child) {
  font-weight: 500;
  color: #004D00;
}

/* Get Quote button */
.rate-table .get-quote {
  background-color:#eefaf0;;
  color: #004D00;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s ease;
}

.rate-table .get-quote:hover {
  background-color: #004D00;
  color: white;
}
.tour-meta-item span {
  margin-left: 8px;
}

.rate-table th:first-child {
  text-align: left;
}
.tour-meta-item.locations {
  flex: 1 1;
}

.location-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.location-tag {
  background: rgba(232, 193, 64, 0.2);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  color: #ffffff;
  border: 1px solid rgba(232, 193, 64, 0.3);
  transition: all 0.2s ease;
}

.location-tag:hover {
  background: rgba(232, 193, 64, 0.3);
  transform: translateY(-1px);
}


/* 태블릿: max-width 1024px */
@media (max-width: 1025px) {
  .main-content {
    margin: 2rem;
    flex-direction: column;
  }
  .image-and-info {
    flex-direction: column;
    align-items: center;
  }
  .main-image-container {
    margin-right: 15px;
    margin-bottom: 15px;
  }
  .info-section {
    width: 100%;
    padding: 10px;
  }
  .tour-content {
    grid-template-columns: 1fr;
  }
  
  .tour-sidebar {
    position: static;
  }
  .icon-cross , .icon-check{
    font-size: 0.8rem;
    min-width: 20px;
    min-height: 20px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    justify-content: center;
    align-self: flex-start;
    margin-top: 3px;
  }
  .exclusion-list li , .inclusion-list li{
    align-items: flex-start;
    flex-wrap: nowrap;
    display: flex;
  }
  .exclusion-list li span:last-child, .inclusion-list li span:last-child{
    flex: 1 1;
    word-break: break-word;
  }
}
@media  (min-width: 800px) and (max-width: 1024px) {
.tour-details-content{
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
}

.thumbnail-gallery-vertical{

  min-width: 130px;
  flex: 0 1;
  gap:0.5rem;
  border-radius: 2px;
}
.thumbnail-image{
  width: 100px;
  height: 60px;
  border-radius: 5px;
}
.tour-hero{
  height: 30rem;
}

}
@media (max-width: 768px) {
.main-content{
  flex-direction: column;
}
.image-gallery{
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.gallery-image{
  width: calc(50% - 10px); 
  max-width: 100%;
  box-sizing: border-box;
  padding: 5px;
}
.gallery-image:nth-child(n+4){
  display:none;
}
.itinerary{
  flex:1 1;
  border: none;
  border-radius: 25px;
  padding: 7px;
}
.sidebar{
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.survey-form{
  width:100%;
  max-width: 100%;
  margin: 20px auto;

}
.thumbnail-gallery {
  gap: 5px;
}
.thumbnail-image {
  width: 40px;
  height: 40px;
}
.tour-nav{
  display: flex;
  gap: 0.5rem;
}
.tour-details-content{
  display: flex;
  flex-direction: column;
}
.info-section{
  width: 85%;
  padding: 1rem;
}
.tour-sidebar{
 width: 100%;
}

.survey-form {
  width: 85% !important;
  max-width: 100%;
  align-self: center;
  margin: 20px auto;
  order: 3;
}

.sidebar > div:last-child {
  width: 100%;
  flex-basis: 100%;
  justify-content: center;
}

.icon-text {
  gap: 1rem;
}

.day-header {
  padding: 0.75rem;
}

.day-content {
  padding: 1rem;
}
.tour-hero {
  height: 400px;
}

.thumbnail-gallery-vertical {
  display: none;
}

.tour-hero-content h1 {
  font-size: 2rem;
}

.requirements-list {
  grid-template-columns: repeat(2, 1fr);
}
.tour-meta-item.locations {
  width: 100%;
}

.location-list {
  margin-top: 4px;
}

.location-tag {
  font-size: 0.8rem;
  padding: 3px 10px;
}
.rate-table {
    margin: 0;
    width: 100%;
  }

  .rate-table thead {
    display: none; 
  }

  .rate-table, 
  .rate-table tbody, 
  .rate-table tr {
    display: block;
    width: 100%;
  }

  .rate-table tr {
    margin-bottom: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    padding: 15px;
  }

  .rate-table td {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    padding: 8px 0;
    font-size: 0.85rem;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  .rate-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #004D00;
    font-size: 0.8rem;
  }

  .rate-table td:last-child {
    border-bottom: none;
  }

  .rate-table .get-quote {
    grid-column: 1 / -1;
    margin-top: 10px;
  }
.tour-itinerary {
  padding: 1rem;
}

.day-header {
  padding: 0.75rem;
}

.day-content {
  padding: 1rem;
}
}
@media (max-width: 480px) {
  .tour-details {
    padding: 10px;
  }

  .tour-hero {
    height: 300px;
    margin: 10px 0;
  }

  .tour-hero-content {
    bottom: 20px;
    left: 20px;
  }

  .tour-details h1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .tour-meta {
    flex-direction: column;
    gap: 0.5rem;
  }

  .tour-meta-item {
    font-size: 0.9rem;
  }

  .tour-nav {
    gap: 0;
    border-bottom: none;
  }

  .tour-nav-item {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    text-align: center;
    border-bottom: none;
  }

  .tour-nav-item.active {
    border-bottom: 3px solid #004D00;
  }

  .tour-details-content {
    margin-top: 1rem;
    gap: 1rem;
  }
.tour-overview{
  margin-left: 10px;
}
  .tour-overview p {
    font-size: 0.9rem;
    line-height: 1.5;
    margin-bottom: 1rem;
  }

  .activities-list {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .activities-list li {
    font-size: 0.9rem;
  }

  .includes-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .inclusions, .exclusions {
    padding: 1rem;
  }

  .inclusion-list li, .exclusion-list li {
    font-size: 0.85rem;
    padding: 0.3rem 0;
  }

  .day-header {
    padding: 0.75rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .day-title {
    font-size: 0.9rem;
    gap: 6px;
    width: 80%;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: baseline;
  }

  .day-number {
    white-space: nowrap;
    font-size: 0.9rem;
    padding-right: 5px;
    line-height: 1.4;
    margin: 0;
  }

  .day-title h3 {
    font-size: 0.9rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    grid-column: 2;
    margin: 0;
    line-height: 1.4;
  }

  .toggle-btn {
    min-width: 24px;
    flex-shrink: 0;
    align-self: baseline;
    margin-top: 0;
    position: relative;
    top: -1px;
  }

  .day-content {
    padding: 0.75rem;
  }

  .timeline {
    font-size: 0.85rem;
  }

  .day-image {
    height: 200px;
    margin-bottom: 15px;
  }

  .rate-table {
    margin: 0;
    width: 100%;
  }

  .rate-table thead {
    display: none; 
  }

  .rate-table, 
  .rate-table tbody, 
  .rate-table tr {
    display: block;
    width: 100%;
  }

  .rate-table tr {
    margin-bottom: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    padding: 15px;
  }

  .rate-table td {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    padding: 8px 0;
    font-size: 0.85rem;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  .rate-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #004D00;
    font-size: 0.8rem;
  }

  .rate-table td:last-child {
    border-bottom: none;
  }

  .rate-table .get-quote {
    grid-column: 1 / -1;
    margin-top: 10px;
  }

  .location-list {
    margin-top: 8px;
  }

  .location-tag {
    font-size: 0.75rem;
    padding: 2px 4px;
  }

  .icon-cross , .icon-check{
    font-size: 0.8rem;
    min-width: 20px;
    min-height: 20px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    justify-content: center;
    align-self: flex-start;
    margin-top: 3px;
  }
  .exclusion-list li , .inclusion-list li{
    align-items: flex-start;
    flex-wrap: nowrap;
    display: flex;
  }
  .exclusion-list li span:last-child, .inclusion-list li span:last-child{
    flex: 1 1;
    word-break: break-word;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/tourDetails.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;AACA,iBAAiB;AACjB;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;AACA;EACE,SAAO;EACP,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uEAAuE;EACvE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;;AAGA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA,aAAa;AACb;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;EACE,sBAAsB;AACxB;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;;AAEjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,SAAS;EACT,4BAA4B;AAC9B;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;;;AAIA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,YAAY;;AAEZ;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA,cAAc;;AAEd;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;;;AAIA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;;AAErB;AACA,UAAU;AACV;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;;AAGA,0BAA0B;AAC1B;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,SAAO;IACP,sBAAsB;EACxB;AACF;AACA;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;AACA;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,QAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;;AAEnB;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;CACC,WAAW;AACZ;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;IACI,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,MAAM;IACN,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;EACE,iBAAiB;AACnB;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,+BAA+B;IAC/B,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,SAAO;IACP,sBAAsB;EACxB;AACF","sourcesContent":[".tour-details {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 20px;\n}\n.tour-details h1{\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  color: white;\n  text-shadow: 5px 5px 4px rgba(0, 0, 0, 0.486);\n}\n.tour-details h2{\n  font-size: 1.2rem;\n  color: #004D00;  \n  text-align: left;\n}\n.tour-details p{\n  padding: 10px 0px;\n  font-size: 0.9rem;\n  line-height: 2;\n  color: #1a1919;\n  margin-bottom: 1.5rem;\n}\n/* Hero Section */\n.tour-hero {\n  display: flex;\n  height: 40rem;\n  margin: 20px 0;\n}\n.main-image-container {\n  flex: 1;\n  position: relative;\n}\n.main-image-container::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 50%;\n  background: linear-gradient(to bottom, transparent, rgba(2, 2, 2, 0.7));\n  border-radius: 16px;\n}\n.tour-hero-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 16px;\n}\n\n.tour-hero-content {\n  position: absolute;\n  bottom: 40px;\n  left: 40px;\n  color: white;\n  z-index: 1;\n}\n\n.tour-meta {\n  display: flex;\n  gap: 2rem;\n}\n\n.tour-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.1rem;\n}\n.thumbnail-gallery-vertical {\n  flex: 0.2;\n  min-width: 250px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  background: rgba(255, 255, 255, 0.315);\n  border-radius: 16px;\n  align-self: center;\n  overflow-y: auto;\n  scrollbar-width: none; \n}\n.thumbnail-gallery-vertical::-webkit-scrollbar {\n  display: none; \n}\n.thumbnail-image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 12px;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n}\n\n.thumbnail-image:hover {\n  transform: scale(1.03);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.thumbnail-image.selected {\n  border-color: #e8c140;\n}\n\n\n/* Navigation */\n.tour-nav {\n  display: flex;\n  gap: 1rem;\n  border-bottom: 1px solid #ddd;\n  padding: 0;\n  margin: 0;\n}\n\n.tour-nav-item {\n  padding: 1rem 2rem;\n  font-weight: 600;\n  color: #000;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n}\n\n.tour-nav-item.active {\n  border-bottom: 3px solid #004D00;\n  color: #004D00;\n}\n\n/* Content Layout */\n.tour-details-content {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n/* overview */\n.tour-overview {\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.tour-overview h2 {\n  color: #004D00;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 24px;\n  position: relative;\n}\n\n.tour-overview p {\n  color: #555;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n/* Activities Section */\n.activities {\n  margin-top: 20px;\n}\n\n.activities-title {\n  color: #004d00;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 24px;\n}\n\n.activities-list {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.activities-list li {\n  color: #555;\n  font-size: 16px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.activities-list li::before {\n  content: \"✓\";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  background: #eefaf0;\n  color: #00a650;\n  border-radius: 50%;\n  font-size: 12px;\n}\n  /* Itinerary Styling */\n.tour-itinerary h2 {\n  color: #004D00;\n  font-size: 20px;\n  margin-bottom: 20px;\n}\n\n.itinerary-day {\n  background: #fff;\n  margin-bottom: 15px;\n  border-radius: 4px;\n}\n\n.day-header {\n  padding: 15px 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.day-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 1rem;\n\n}\n\n.day-number {\n  color: #004D00;\n  font-weight: 600;\n}\n\n.day-title h3 {\n  margin: 0;\n  font-size: 16px;\n  color: #004D00;\n}\n\n.toggle-btn {\n  width: 24px;\n  height: 24px;\n  border: 1px solid #004D00;\n  background: transparent;\n  color: #004D00;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  padding: 0;\n}\n\n.day-content {\n  padding: 1.25rem;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-top: none;\n  border-radius: 0 0 8px 8px;\n  font-size: 0.9rem;\n}\n.timeline {\n  font-size: 0.9rem;\n}\n.day-content .timeline ul {\n  padding: 0 20px;  \n  margin: 0;\n  list-style-position: outside;\n}\n\n.day-content .timeline p,\n.day-content .timeline li {\n  margin: 0;\n  padding: 0;\n  line-height: 1.5;\n  font-size: 0.9rem;\n  color: #1a1919;\n}\n\n.day-image {\n  width: 100%;\n  height: 280px;\n  margin-bottom: 20px;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.itinerary-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.itinerary-image:hover {\n  transform: scale(1.05);\n}\n\n\n\n/* Includes/Excludes Section */\n.includes-excludes {\n  margin-top: 30px;\n}\n\n.includes-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n}\n\n.inclusions h2,\n.exclusions h2 {\n  color: #004D00;\n  font-size: 20px;\n  margin-bottom: 20px;\n}\n\n.inclusion-list,\n.exclusion-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.inclusion-list li,\n.exclusion-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.icon-check {\n  color: #004D00;\n  font-weight: bold;\n}\n\n.icon-cross {\n  color: #dc3545;\n  font-weight: bold;\n}\n\n/* Sidebar */\n\n.details-destination{\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #004d00;\n  border: 1px solid #004D00;\n  padding: 0.4rem;\n  border-radius: 5px;\n  font-weight: 500;\n}\n.details-price{\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #004d00;\n}\n.image-and-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n  width: 100%;\n  padding: 10px 10px;\n}\n\n.main-image-container {\n  position: relative;\n  margin-right: 20px;\n}\n\n.main-image {\n  width: 100%;\n  height: 470px;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.info-section h3 {\n  margin: 10px 0;\n  font-size: 1rem;\n  font-weight: 700;\n}\n.info-section p{\n  font-size: 0.8rem;\n  color: #4e4d4d;\n  padding: 0;\n}\n.info-section button{\n  color: white !important;\n  width: 100px;\n  font-size: 0.9rem !important;\n  align-self: flex-end;\n}\n\n.styled-datepicker-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 1rem;\n  color: #004D00;\n  margin-top: 5px;\n}\n\n.styled-datepicker-calendar {\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.styled-input{\n  width: 100%;\n  padding: 5px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 1rem;\n}\n\n\n.main-content {\n  display: flex;\n  gap: 20px;\n  margin-top: 20px;\n  max-width: 1280px;\n  margin: 0 auto;\n}\n/* itinerary */\n\n.itinerary-list {\n  margin-top: 1.5rem;\n}\n\n.itinerary-day {\n  margin-bottom: 1rem;\n}\n\n.day-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background: #fff;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.day-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #2a2a2a;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.location-icon {\n  color: #e8c140;\n  font-size: 1.2rem;\n}\n.icon-text {\n  color: #e8c140;\n  margin-top: 1rem;\n  display: flex;\n  gap: 1.25rem;\n  flex-wrap: wrap;\n}\n.icon-text span {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n}\n\n.itinerary-icon {\n  font-size: 1rem;\n}\n.includes-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  margin-top: 1rem;\n}\n\n.inclusions, .exclusions {\n  padding: 2rem;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid #eee;\n}\n\n.inclusions h2, .exclusions h2 {\n  color: #004D00;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n}\n\n.inclusion-list, .exclusion-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.inclusion-list li, .exclusion-list li {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0;\n  color: #4a4a4a;\n  font-size: 0.95rem;\n}\n.icon-check{\n  content: \"✓\";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  background: #eefaf0;\n  color: #00a650;\n  border-radius: 50%;\n  font-size: 12px;\n}\n\n.icon-cross{\n  content: \"×\";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  background: #fff1f0;\n  color: #ff4d4f;\n  border-radius: 50%;\n  font-size: 14px;\n}\n\n\n\n.you-might-like{\n  color: #004d00;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0.5rem 1rem;\n\n}\n/* rates */\n.tour-rates{\n  background: #fff;\n}\n.rate-table{\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 8px;\n  overflow: hidden;\n}\n.rate-table th,\n.rate-table td {\n  padding: 15px;\n  text-align: center;\n  border-bottom: 1px solid #eee;\n}\n\n.rate-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: #333;\n  text-transform: uppercase;\n  font-size: 0.7rem;\n  white-space: pre-line;\n}\n\n.rate-table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.rate-table td:first-child {\n  text-align: left;\n  font-weight: 500;\n  color: #444;\n}\n\n.rate-table td {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n/* Price cells */\n.rate-table td:not(:first-child):not(:last-child) {\n  font-weight: 500;\n  color: #004D00;\n}\n\n/* Get Quote button */\n.rate-table .get-quote {\n  background-color:#eefaf0;;\n  color: #004D00;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s ease;\n}\n\n.rate-table .get-quote:hover {\n  background-color: #004D00;\n  color: white;\n}\n.tour-meta-item span {\n  margin-left: 8px;\n}\n\n.rate-table th:first-child {\n  text-align: left;\n}\n.tour-meta-item.locations {\n  flex: 1;\n}\n\n.location-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.location-tag {\n  background: rgba(232, 193, 64, 0.2);\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  color: #ffffff;\n  border: 1px solid rgba(232, 193, 64, 0.3);\n  transition: all 0.2s ease;\n}\n\n.location-tag:hover {\n  background: rgba(232, 193, 64, 0.3);\n  transform: translateY(-1px);\n}\n\n\n/* 태블릿: max-width 1024px */\n@media (max-width: 1025px) {\n  .main-content {\n    margin: 2rem;\n    flex-direction: column;\n  }\n  .image-and-info {\n    flex-direction: column;\n    align-items: center;\n  }\n  .main-image-container {\n    margin-right: 15px;\n    margin-bottom: 15px;\n  }\n  .info-section {\n    width: 100%;\n    padding: 10px;\n  }\n  .tour-content {\n    grid-template-columns: 1fr;\n  }\n  \n  .tour-sidebar {\n    position: static;\n  }\n  .icon-cross , .icon-check{\n    font-size: 0.8rem;\n    min-width: 20px;\n    min-height: 20px;\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    justify-content: center;\n    align-self: flex-start;\n    margin-top: 3px;\n  }\n  .exclusion-list li , .inclusion-list li{\n    align-items: flex-start;\n    flex-wrap: nowrap;\n    display: flex;\n  }\n  .exclusion-list li span:last-child, .inclusion-list li span:last-child{\n    flex: 1;\n    word-break: break-word;\n  }\n}\n@media  (min-width: 800px) and (max-width: 1024px) {\n.tour-details-content{\n  padding: 0 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.thumbnail-gallery-vertical{\n\n  min-width: 130px;\n  flex: 0 1;\n  gap:0.5rem;\n  border-radius: 2px;\n}\n.thumbnail-image{\n  width: 100px;\n  height: 60px;\n  border-radius: 5px;\n}\n.tour-hero{\n  height: 30rem;\n}\n\n}\n@media (max-width: 768px) {\n.main-content{\n  flex-direction: column;\n}\n.image-gallery{\n  display:flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n.gallery-image{\n  width: calc(50% - 10px); \n  max-width: 100%;\n  box-sizing: border-box;\n  padding: 5px;\n}\n.gallery-image:nth-child(n+4){\n  display:none;\n}\n.itinerary{\n  flex:1;\n  border: none;\n  border-radius: 25px;\n  padding: 7px;\n}\n.sidebar{\n  display:flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n.survey-form{\n  width:100%;\n  max-width: 100%;\n  margin: 20px auto;\n\n}\n.thumbnail-gallery {\n  gap: 5px;\n}\n.thumbnail-image {\n  width: 40px;\n  height: 40px;\n}\n.tour-nav{\n  display: flex;\n  gap: 0.5rem;\n}\n.tour-details-content{\n  display: flex;\n  flex-direction: column;\n}\n.info-section{\n  width: 85%;\n  padding: 1rem;\n}\n.tour-sidebar{\n width: 100%;\n}\n\n.survey-form {\n  width: 85% !important;\n  max-width: 100%;\n  align-self: center;\n  margin: 20px auto;\n  order: 3;\n}\n\n.sidebar > div:last-child {\n  width: 100%;\n  flex-basis: 100%;\n  justify-content: center;\n}\n\n.icon-text {\n  gap: 1rem;\n}\n\n.day-header {\n  padding: 0.75rem;\n}\n\n.day-content {\n  padding: 1rem;\n}\n.tour-hero {\n  height: 400px;\n}\n\n.thumbnail-gallery-vertical {\n  display: none;\n}\n\n.tour-hero-content h1 {\n  font-size: 2rem;\n}\n\n.requirements-list {\n  grid-template-columns: repeat(2, 1fr);\n}\n.tour-meta-item.locations {\n  width: 100%;\n}\n\n.location-list {\n  margin-top: 4px;\n}\n\n.location-tag {\n  font-size: 0.8rem;\n  padding: 3px 10px;\n}\n.rate-table {\n    margin: 0;\n    width: 100%;\n  }\n\n  .rate-table thead {\n    display: none; \n  }\n\n  .rate-table, \n  .rate-table tbody, \n  .rate-table tr {\n    display: block;\n    width: 100%;\n  }\n\n  .rate-table tr {\n    margin-bottom: 20px;\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    padding: 15px;\n  }\n\n  .rate-table td {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n    padding: 8px 0;\n    font-size: 0.85rem;\n    text-align: left;\n    border-bottom: 1px solid #eee;\n  }\n\n  .rate-table td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #004D00;\n    font-size: 0.8rem;\n  }\n\n  .rate-table td:last-child {\n    border-bottom: none;\n  }\n\n  .rate-table .get-quote {\n    grid-column: 1 / -1;\n    margin-top: 10px;\n  }\n.tour-itinerary {\n  padding: 1rem;\n}\n\n.day-header {\n  padding: 0.75rem;\n}\n\n.day-content {\n  padding: 1rem;\n}\n}\n@media (max-width: 480px) {\n  .tour-details {\n    padding: 10px;\n  }\n\n  .tour-hero {\n    height: 300px;\n    margin: 10px 0;\n  }\n\n  .tour-hero-content {\n    bottom: 20px;\n    left: 20px;\n  }\n\n  .tour-details h1 {\n    font-size: 1.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .tour-meta {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .tour-meta-item {\n    font-size: 0.9rem;\n  }\n\n  .tour-nav {\n    gap: 0;\n    border-bottom: none;\n  }\n\n  .tour-nav-item {\n    padding: 0.75rem 1rem;\n    font-size: 0.9rem;\n    text-align: center;\n    border-bottom: none;\n  }\n\n  .tour-nav-item.active {\n    border-bottom: 3px solid #004D00;\n  }\n\n  .tour-details-content {\n    margin-top: 1rem;\n    gap: 1rem;\n  }\n.tour-overview{\n  margin-left: 10px;\n}\n  .tour-overview p {\n    font-size: 0.9rem;\n    line-height: 1.5;\n    margin-bottom: 1rem;\n  }\n\n  .activities-list {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .activities-list li {\n    font-size: 0.9rem;\n  }\n\n  .includes-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .inclusions, .exclusions {\n    padding: 1rem;\n  }\n\n  .inclusion-list li, .exclusion-list li {\n    font-size: 0.85rem;\n    padding: 0.3rem 0;\n  }\n\n  .day-header {\n    padding: 0.75rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n\n  .day-title {\n    font-size: 0.9rem;\n    gap: 6px;\n    width: 80%;\n    display: grid;\n    grid-template-columns: auto 1fr;\n    align-items: baseline;\n  }\n\n  .day-number {\n    white-space: nowrap;\n    font-size: 0.9rem;\n    padding-right: 5px;\n    line-height: 1.4;\n    margin: 0;\n  }\n\n  .day-title h3 {\n    font-size: 0.9rem;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    white-space: normal;\n    grid-column: 2;\n    margin: 0;\n    line-height: 1.4;\n  }\n\n  .toggle-btn {\n    min-width: 24px;\n    flex-shrink: 0;\n    align-self: baseline;\n    margin-top: 0;\n    position: relative;\n    top: -1px;\n  }\n\n  .day-content {\n    padding: 0.75rem;\n  }\n\n  .timeline {\n    font-size: 0.85rem;\n  }\n\n  .day-image {\n    height: 200px;\n    margin-bottom: 15px;\n  }\n\n  .rate-table {\n    margin: 0;\n    width: 100%;\n  }\n\n  .rate-table thead {\n    display: none; \n  }\n\n  .rate-table, \n  .rate-table tbody, \n  .rate-table tr {\n    display: block;\n    width: 100%;\n  }\n\n  .rate-table tr {\n    margin-bottom: 20px;\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    padding: 15px;\n  }\n\n  .rate-table td {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n    padding: 8px 0;\n    font-size: 0.85rem;\n    text-align: left;\n    border-bottom: 1px solid #eee;\n  }\n\n  .rate-table td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #004D00;\n    font-size: 0.8rem;\n  }\n\n  .rate-table td:last-child {\n    border-bottom: none;\n  }\n\n  .rate-table .get-quote {\n    grid-column: 1 / -1;\n    margin-top: 10px;\n  }\n\n  .location-list {\n    margin-top: 8px;\n  }\n\n  .location-tag {\n    font-size: 0.75rem;\n    padding: 2px 4px;\n  }\n\n  .icon-cross , .icon-check{\n    font-size: 0.8rem;\n    min-width: 20px;\n    min-height: 20px;\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    justify-content: center;\n    align-self: flex-start;\n    margin-top: 3px;\n  }\n  .exclusion-list li , .inclusion-list li{\n    align-items: flex-start;\n    flex-wrap: nowrap;\n    display: flex;\n  }\n  .exclusion-list li span:last-child, .inclusion-list li span:last-child{\n    flex: 1;\n    word-break: break-word;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
